export const CACHE_TIMESTAMP_KEY = '__wt-experiment-variants-last';

export function setCacheTimestamp(): void {
  localStorage.setItem(CACHE_TIMESTAMP_KEY, new Date().toISOString());
}

export function isCacheExpired(): boolean | undefined {
  if (!window.localStorage) {
    return true;
  }

  try {
    const lastEvent = localStorage.getItem(CACHE_TIMESTAMP_KEY);

    if (!lastEvent) {
      return true;
    }

    const diffMs = Math.abs(
      new Date().getTime() - new Date(lastEvent).getTime()
    );
    const diffMins = Math.floor(diffMs / 60000);

    // 24 hours
    if (diffMins > 1440) {
      return true;
    }

    return false;
  } catch (err) {
    return true;
  }
}

// Convenience export for module spies
export default {
  CACHE_TIMESTAMP_KEY,
  isCacheExpired,
  setCacheTimestamp,
};
